const whyChooseData = [
  {
    image: "images/prof.png",
    title: "Unmatched Professional Service",
    text: "Specially Trained Technicians at Affordable Price"
  },
  {
    image: "images/ic1.png",
    title: "Transparent Charges (No Hidden Charges)",
    text: "Before Any Part Replacement, We Take Your Approval"
  },
  {
    image: "images/ic1.png",
    title: "Affordable AMCs",
    text: "Great way to get regular and timely repairs"
  },
  {
    image: "images/exp.png",
    title: "16 Years of RO Service Experience",
    text: "Installed 47,000 RO in Hyderabad"
  }
];

export default whyChooseData;